import { configureStore } from '@reduxjs/toolkit'
import { charactersApi } from './api/characters.api'
import { setupListeners } from '@reduxjs/toolkit/query'
import { chroniclesApi } from './api/chronicles.api'
import { invitesApi } from './api/invites.api'

const Store = configureStore({
  reducer: {
    [charactersApi.reducerPath]: charactersApi.reducer,
    [chroniclesApi.reducerPath]: chroniclesApi.reducer,
    [invitesApi.reducerPath]: invitesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      charactersApi.middleware,
      chroniclesApi.middleware,
      invitesApi.middleware,
    ]),
})

setupListeners(Store.dispatch)

export { Store }
export {
  useFetchCharactersQuery,
  useFetchCharacterQuery,
  useUpdateCharacterMutation,
  useCreateCharacterMutation,
  useDeleteCharacterMutation,
} from './api/characters.api'
export {
  useFetchChroniclesQuery,
  useFetchChronicleQuery,
  useCreateChronicleMutation,
  useDeleteChronicleMutation,
} from './api/chronicles.api'

export {
  useFetchInvitesQuery,
  useCreateInviteMutation,
  useUpdateInviteMutation,
  useDeleteInviteMutation,
} from './api/invites.api'
